(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nexus-split-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  var reduced=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function rgba(hex,a){hex=(hex||'#22d3ee').replace('#','');if(hex.length===3)hex=hex.split('').map(function(c){return c+c;}).join('');var nn=parseInt(hex,16);return 'rgba('+((nn>>16)&255)+','+((nn>>8)&255)+','+(nn&255)+','+a+')';}
  function circuit(ctx,w,h,color,rnd,t){var step=Math.max(14,Math.round(w/16));ctx.lineWidth=1.4;var cols=Math.ceil(w/step),rows=Math.ceil(h/step);for(var c=0;c<=cols;c++){var x=c*step+step/2,y=-2;ctx.strokeStyle=rgba(color,0.16+rnd()*0.3);ctx.beginPath();ctx.moveTo(x,y);var yy=y;while(yy<h+step){var seg=step*(1+Math.floor(rnd()*2));yy+=seg;ctx.lineTo(x,Math.min(yy,h));if(rnd()>0.5&&yy<h){var nx=x+(rnd()>.5?step:-step);ctx.lineTo(nx,Math.min(yy,h));x=nx;}}ctx.stroke();}for(var k=0;k<cols*2;k++){var px=Math.floor(rnd()*cols)*step+step/2,py=Math.floor(rnd()*rows)*step+step/2,pulse=(Math.sin(t*2+k)+1)/2;ctx.fillStyle=rgba(color,0.5+pulse*0.5);ctx.fillRect(px-2.5,py-2.5,5,5);ctx.strokeStyle=rgba(color,0.2*pulse);ctx.strokeRect(px-5,py-5,10,10);}}
  function mulberry(a){return function(){a|=0;a=(a+0x6D2B79F5)|0;var t=Math.imul(a^(a>>>15),1|a);t=(t+Math.imul(t^(t>>>7),61|t))^t;return((t^(t>>>14))>>>0)/4294967296;};}
  function initShow(el){
    if(el.dataset.nxInit)return; el.dataset.nxInit='1';
    var nowS=Date.now()/1000;
    var slides=[].slice.call(el.querySelectorAll('.nx-slide')).filter(function(s){
      var w=s.getAttribute('data-nx-win'),ok=true;
      if(w){var st=parseFloat(s.getAttribute('data-nx-start'))||0,en=parseFloat(s.getAttribute('data-nx-end'))||0;
        if(w==='drop')ok=(nowS>=st&&nowS<en);else if(w==='after')ok=(nowS>=en);}
      if(ok){s.removeAttribute('hidden');}else{s.setAttribute('hidden','');s.classList.remove('is-on');s.setAttribute('aria-hidden','true');}
      return ok;
    });
    if(slides.length<1)return;
    var barsWrap=el.querySelector('[data-nx-bars]');
    var i=0,n=slides.length,timer=null,bars=[];
    if(barsWrap){barsWrap.innerHTML='';slides.forEach(function(s,idx){var b=document.createElement('span');b.className='nx-bar'+(idx===0?' on':'');b.addEventListener('click',function(){go(idx);reset();});barsWrap.appendChild(b);bars.push(b);});}
    function go(k){i=(k+n)%n;slides.forEach(function(s,j){var on=(j===i);s.classList.toggle('is-on',on);s.setAttribute('aria-hidden',on?'false':'true');});bars.forEach(function(b,j){b.classList.toggle('on',j===i);});}
    function reset(){var sec=el.closest('.nx-hero');var ms=parseInt(sec&&sec.getAttribute('data-autoplay'),10)||4200;if(timer)clearInterval(timer);if(n>1)timer=setInterval(function(){go(i+1);},ms);}
    var prev=el.querySelector('[data-nx-prev]'),next=el.querySelector('[data-nx-next]');
    if(prev)prev.addEventListener('click',function(){go(i-1);reset();});
    if(next)next.addEventListener('click',function(){go(i+1);reset();});
    el.addEventListener('mouseenter',function(){if(timer){clearInterval(timer);timer=null;}});
    el.addEventListener('mouseleave',reset);
    go(0);reset();
  }
  function initGen(cv){
    if(cv.dataset.nxInit)return; cv.dataset.nxInit='1';
    var color=cv.getAttribute('data-color')||'#22d3ee',t0=performance.now();
    function fit(){var r=cv.getBoundingClientRect();if(r.width<2)return;var dpr=Math.min(window.devicePixelRatio||1,2);cv.width=Math.round(r.width*dpr);cv.height=Math.round(r.height*dpr);cv._w=Math.round(r.width);cv._h=Math.round(r.height);cv.getContext('2d').setTransform(dpr,0,0,dpr,0,0);}
    function draw(t){if(!cv._w)return;var ctx=cv.getContext('2d');ctx.clearRect(0,0,cv._w,cv._h);circuit(ctx,cv._w,cv._h,color,mulberry(1234),t*0.5);}
    fit();draw(0.6);
    if(!reduced){(function loop(){requestAnimationFrame(loop);draw((performance.now()-t0)/1000);})();}
    var rt;window.addEventListener('resize',function(){clearTimeout(rt);rt=setTimeout(function(){fit();draw((performance.now()-t0)/1000);},150);});
  }
  function boot(root){var s=root||document;s.querySelectorAll('.nx-hero__show').forEach(initShow);s.querySelectorAll('.nx-gen').forEach(initGen);}
  if(document.readyState!=='loading')boot();else document.addEventListener('DOMContentLoaded',function(){boot();});
  document.addEventListener('shopify:section:load',function(e){boot(e.target);});
})();

  } catch(e) { console.error(e); }
})();
})();
